// extracted by mini-css-extract-plugin
export default {"global_hover_card":"GlobalHoverCard_global_hover_card__xe43+"};